import React, { useState } from "react";
import { T } from "react-translator-component";
import { Modal, Box, Typography, FormControlLabel, Checkbox, Button } from "@mui/material";
import { colors } from "../../../common/colors";
import SubmitButton from "../../SubmitButton";

// Define the props interface
interface LeaveGroupConfirmationProps {
  open: boolean;
  showButton?: boolean;
  headerText?: string;
  message1?: string;
  message2?: string;
  message3?: string;
  onClose: () => void;
  onContinue: () => any;
  showCheckBoxText?:string;
}

const LeaveGroupConfirmation: React.FC<LeaveGroupConfirmationProps> = (
  { open, onClose, onContinue, showCheckBoxText, headerText = '', message1 = '', message2 = '', message3 = '' }
) => {
  const [check1,setCheck1]=useState<boolean>(false);

  const splitText = (text: string) => {
    return text.split('\n')
  }

  const existSplitText = (text: string) => {
    const result = text.indexOf('\n')
    return result > 0 ? true : false
  }

  const yesButtonStyle = {
    cursor: !check1 && showCheckBoxText ? "default" : "pointer",
    pointerEvents: !check1 && showCheckBoxText ? "none" : "auto",
    opacity: !check1 && showCheckBoxText ? 0.5 : 1, // Optional: Dim the button when disabled
    color: colors.farm_white,
    textAlign: "center",
    backgroundColor: colors.farm_blue200,
    border: "2px solid " + colors.farm_blue200,
    margin: "0px 30px",
    borderRadius: "10px",
    borderLeft: "none",
    padding: "10px",
  }

  const noButtonStyle = {
    cursor: "pointer",
    textAlign: "center",
    padding: "10px",
    color: colors.farm_blue200,
    margin: "5px 30px 30px 30px",
    borderRadius: "10px",
    border: "2px solid " + colors.farm_gray100,
  }

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "85%",
            maxWidth: 300,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "30px",
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <Typography variant="body1" sx={{ mb: 2, textAlign: "center", paddingTop: "10px" }}>
            {existSplitText(headerText) ? (
              <>
                {splitText(headerText).map((text: string) => (
                  <span key={text} style={{display: 'block'}}>{text}</span>
                ))}
              </>
            ) : (
              headerText
            )}
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, textAlign: "center", padding: "5px 20px" }}>
            {existSplitText(message1) ? (
              <>
                {splitText(message1).map((text: string) => (
                  <span key={text} style={{display: 'block'}}>{text}</span>
                ))}
              </>
            ) : (
              message1
            )}
          </Typography>

          <Typography variant="body1" sx={{  textAlign: "center", padding: "5px 20px" }}>
            {existSplitText(message2) ? (
              <>
                {splitText(message2).map((text: string) => (
                  <span key={text} style={{display: 'block'}}>{text}</span>
                ))}
              </>
            ) : (
              message2
            )}
          </Typography>

          <Typography variant="body1" sx={{ mb: 2, textAlign: "center", padding: "5px 5px" }}>
            {existSplitText(message3) ? (
              <>
                {splitText(message3).map((text: string) => (
                  <span key={text} style={{display: 'block'}}>{text}</span>
                ))}
              </>
            ) : (
              message3
            )}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%", // Ensures it takes full width
            }}
          >
          {showCheckBoxText&& <FormControlLabel
            control={<Checkbox checked={check1} onChange={(e) => setCheck1(e.target.checked)} />}
            color="error"
            sx={{
              color: false ? colors.farm_red600 : "black"
            }}
            label={showCheckBoxText}
          />}
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <SubmitButton
              sx={yesButtonStyle}
              size={"large"}
              variant="contained"
              validate={async () => check1 || showCheckBoxText === undefined}
              onSubmit={onContinue}
            >
              {T('pay')}
            </SubmitButton>
            <br></br>
            <Button
              sx={noButtonStyle}
              onClick={onClose}
            >
              {T('close')}
            </Button>
          </Box>
          <br/>
        </Box>
      </Modal>
    </>
  );
};

export default LeaveGroupConfirmation;
